(function () {
  'use strict';

  /* ── Toggle: only adds the product, never removes (use cart item to remove) */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.classList.contains('g3-cart-addon__input')) return;

    var wrapper = input.closest('.g3-cart-addon');
    if (!wrapper) return;

    var variantId = parseInt(wrapper.dataset.variantId, 10);
    if (!variantId) return;

    if (!input.checked) return; /* toggle can only turn ON here */

    setLoading(wrapper, true);

    fetch('/cart/add.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return Promise.reject(r);
        return r.json();
      })
      .then(function () {
        /* Reload the cart drawer section so the addon appears as a cart item */
        fetch('/?sections=cart-drawer')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!data['cart-drawer']) return;
            var freshDoc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');

            swap(freshDoc, '#CartDrawer-CartItems');
            swap(freshDoc, '.cart-drawer__footer');
            updateCartCount(freshDoc);

            /* Remove the addon widget — it's now a cart item */
            var addonEl = document.querySelector('.g3-cart-addon');
            if (addonEl) addonEl.remove();
          });
      })
      .catch(function () {
        input.checked = false;
        setLoading(wrapper, false);
      });
  });

  function swap(freshDoc, selector) {
    var fresh = freshDoc.querySelector(selector);
    var current = document.querySelector(selector);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function updateCartCount(freshDoc) {
    var countEl = freshDoc.querySelector('.cart-count-bubble [aria-hidden]');
    if (!countEl) return;
    document.querySelectorAll('.cart-count-bubble [aria-hidden]').forEach(function (el) {
      el.textContent = countEl.textContent;
    });
    document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach(function (el) {
      var fresh = freshDoc.querySelector('.cart-count-bubble .visually-hidden');
      if (fresh) el.textContent = fresh.textContent;
    });
  }

  function setLoading(wrapper, on) {
    wrapper.classList.toggle('g3-cart-addon--loading', on);
  }
})();
